import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MensagensService} from 'max-ng-lib';
import {GenericRoteirizadorService} from '../../../core/services';
import {SemPararModel} from '../models/sem-parar/sem-parar.model';
import {Pedagio} from '../models/pedagio.model';
import {ValidacaoSempararModel} from '../models/sem-parar/validacao-semparar.model';
import {TarifasSemPararModel} from '../models/sem-parar/tarifas-sem-parar.model';
import {RotaSemPararModel} from '../models/sem-parar/rota-sem-parar.model';
import {RequestSemPararModel} from '../models/sem-parar/request-sem-parar.model';
import {ViagemSemPararModel} from '../models/sem-parar/viagem-sem-parar.model';
import {ViagemErroSemPararModel} from '../models/sem-parar/viagem-erro-sem-parar.model';
import {VpoSemPararModel} from '../models/sem-parar/vpo-sem-parar.model';
import {ViagemResumoSemPararModel} from '../models/sem-parar/viagem-resumo-sem-parar.model';

@Injectable({
  providedIn: 'root'
})
export class SemPararPedagioService extends GenericRoteirizadorService {

  constructor(
    private mensagensService: MensagensService,
    private httpClient: HttpClient) {
    super();
  }

  getMensagensService(): MensagensService {
    return this.mensagensService;
  }

  getHttpClient(): HttpClient {
    return this.httpClient;
  }

  getUrlRecurso(): string {
    return '/semParar';
  }


  listarPaginado(filtros, pageable) {
    return this.post<SemPararModel[]>(`/pesquisar?${pageable}`, {
      dados: filtros
    });
  }

  obterPorId(id: string) {
    return this.get<SemPararModel>(`/${id}`);
  }

  salvar(dados: any) {
    return this.post<SemPararModel>(`/salvar`, {
      dados
    });
  }

  listarPedagios() {
    return this.get<Pedagio[]>(`/`);
  }

  obterValorPracasRota(dadosRequest: RequestSemPararModel) {
    return this.post<TarifasSemPararModel>(`/obterValorPracasRota`, {
      dados: dadosRequest, exibirLoading: false
    });
  }

  obterRotaTemporaria(dadosRequest: RequestSemPararModel) {
    return this.post<RotaSemPararModel>(`/obterRotaTemporaria`, {
      dados: dadosRequest, exibirLoading: false
    });
  }

  obterValorTotalRota(dadosRequest: RequestSemPararModel) {
    return this.post<TarifasSemPararModel>(`/obterValorTotal`, {
      dados: dadosRequest, exibirLoading: false
    });
  }

  validarCredenciais(dadosParaValidar: {
    identificador: string
    login: string
    senha: string
    token: string
  }) {
    return this.post('/validarCredenciais', {dados: dadosParaValidar});
  }

  validarVeiculo(idVeiculo: string) {
    return this.get<ValidacaoSempararModel>('/validarVeiculo/' + idVeiculo,);
  }

  atualizarPracasPedagioPorIntegracao() {
    return this.get<ValidacaoSempararModel>('/atualizarPracasPedagioPorIntegracao', {exibirLoading: false});
  }

  realizarCompra(informacoesRota: RequestSemPararModel) {
    return this.post<ViagemSemPararModel>('/realizarCompra', {dados: informacoesRota, exibirLoading: false});
  }

  existeReciboRomaneio(idRomaneio: number | string) {
    return this.get<boolean>('/existeViagemRomaneio/' + idRomaneio, {exibirLoading: false});
  }

  obterRecibo(informacoesRota: RequestSemPararModel) {
    return this.post<ViagemSemPararModel>('/obterRecibo', {dados: informacoesRota, exibirLoading: false});
  }

  cancelar(idRomaneio: number, idViagem: number) {
    return this.put<ValidacaoSempararModel>(`/cancelarValePedagio?idRomaneio=${idRomaneio}&idViagem=${idViagem}`, {exibirLoading: false});
  }

  obterMsgErroViagem(idRomaneio: number | string) {
    return this.get<ViagemErroSemPararModel>('/verificarErroViagem/' + idRomaneio, {exibirLoading: true});
  }

  obterIdsVpo(idRomaneio: number, idViagem: number) {
    return this.get<VpoSemPararModel>(`/viagem/vpos?idRomaneio=${idRomaneio}&idViagem=${idViagem}`, {exibirLoading: false});
  }

  existePracasInvalidas() {
    return this.get<boolean>('/existePracasInvalidas', {exibirLoading: false});
  }

  obterResumoViagem(idRomaneio: number | string) {
    return this.get<ViagemResumoSemPararModel>('/viagem/resumo/' + idRomaneio, {exibirLoading: false});
  }

}
